// 导出页面为PDF格式
import html2canvas from 'html2canvas'
import JsPDF from './jspdf.debug'
import watermark from './waterMark'

import JSZip from 'jszip';
import saveAs from 'jszip/vendor/FileSaver';
import {setDownloadFileCount} from "@/server/mainCredit.js"

export default {
    install(Vue, options) {
        
        Vue.prototype.getCanvasPdf = function (domId, pdfname, widthcopy, heightcopy, morepdfList,fileId) {
            let w=widthcopy||0
            let h=heightcopy||0
            let backInfo = watermark.set('漯河公共资源交易中心', 20, "#606266", 'watermarkDom', w, h)

            let morepdfListcopy = morepdfList || []

            try {
                const loading = this.$loading({
                    lock: true,
                    text: '导出中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                html2canvas(document.getElementById(domId)).then(
                    function (canvas) {
                        var contentWidth = canvas.width;
                        var contentHeight = canvas.height;

                        //一页pdf显示html页面生成的canvas高度;
                        var pageHeight = contentWidth / 592.28 * 841.89;
                        //未生成pdf的html页面高度
                        var leftHeight = contentHeight;
                        //pdf页面偏移
                        var position = 0;
                        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                        var imgWidth = 595.28;
                        var imgHeight = 592.28 / contentWidth * contentHeight;

                        var pageData = canvas.toDataURL('image/jpeg', 1.0);

                        var pdf = new JsPDF('', 'pt', 'a4');

                        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
                        //当内容未超过pdf一页显示的范围，无需分页
                        if (leftHeight < pageHeight) {
                            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
                        } else {
                            while (leftHeight > 0) {
                                pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                                leftHeight -= pageHeight;
                                position -= 841.89;
                                //避免添加空白页
                                if (leftHeight > 0) {
                                    pdf.addPage();
                                }
                            }
                        }
                        if (backInfo) {
                            // const totalPages = pdf.internal.getNumberOfPages() // 获取当前pdf的页数
                            // for (let i = 1; i <= totalPages; i++) {
                            // pdf.setPage(i) // 通过循环，跳转至相应的页进行设置
                            // // pdf.addImage("", 'JPEG', 10, 20, a4w, Math.min(a4h, a4w * page.height / page.width));  
                            // // 后面可以进行相应的数据写入操作了，例如以下的添加水印操作
                            // pdf.setTextColor(150)
                            // pdf.text(50, 0, 'Watermark')
                            // }
                              const setCount=function(){
                                setDownloadFileCount(fileId).then((res)=>{
                                  if(res.data.code==1){
                                       console.log("下载成功")
                                  }
                                })
                              }
                            pdf = pdf.output('blob')
                            const zip = new JSZip();  //生产zip的压缩容器
                           
                          
                            if (morepdfListcopy && morepdfListcopy.length > 0) {
                                morepdfListcopy.forEach((element) => {

                                    // urltopdf(element.fileName,element.blob)
                                    zip.file(element.fileName,element.blob);
                                })
                            }
                         

                            zip.file(pdfname + '.pdf', pdf)  //每次并发时就写入一个文件到文件夹
                            zip.generateAsync({ type: 'blob' }).then(blob => {
                                saveAs(blob, pdfname + ".zip");
                                let flag=watermark.remove(20,"#606266",'watermarkDom') 
                                // 调用接口保存下载记录
                                setCount()
                                if(flag){
                                    loading.close();
                                }
                            }, function (err) {
                               console.log("文件下载失败");
                            })
                            // pdf.save(pdfname);
                        }
                        //无效果

                    }
                )
            } catch (error) {
                console.log(error);
            }

        }
    }
}